import { useTranslation } from 'react-i18next';

type DeliveryStatus = 'heading_to_pickup' | 'at_pickup' | 'picked_up' | 'heading_to_customer' | 'at_customer';

interface QuickContactBarProps {
  storePhone: string;
  customerPhone: string;
  pickupAddress: string;
  deliveryAddress: string;
  status: DeliveryStatus;
}

export default function QuickContactBar({ 
  storePhone, 
  customerPhone, 
  pickupAddress, 
  deliveryAddress,
  status 
}: QuickContactBarProps) {
  const { t } = useTranslation();
  
  const isPickupPhase = ['heading_to_pickup', 'at_pickup'].includes(status);
  const activePhone = isPickupPhase ? storePhone : customerPhone;
  const activeAddress = isPickupPhase ? pickupAddress : deliveryAddress;
  
  const handleCall = () => {
    window.open(`tel:${activePhone}`);
  };
  
  const handleNavigate = () => {
    window.open(`https://maps.google.com/?q=${encodeURIComponent(activeAddress)}`);
  };
  
  const handleMessage = () => {
    window.open(`sms:${activePhone}`);
  };
  
  return (
    <div className="bg-white rounded-2xl p-3 shadow-md">
      <p className="text-xs font-bold text-gray-600 mb-3 px-1">
        {t('quickActions') || 'Quick Actions'}
      </p>
      
      <div className="grid grid-cols-3 gap-2">
        <button
          onClick={handleCall}
          className="flex flex-col items-center justify-center gap-2 p-3 bg-green-50 rounded-xl active:scale-95 transition-transform"
        >
          <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center">
            <i className="ri-phone-line text-white text-lg"></i>
          </div>
          <span className="text-xs font-semibold text-gray-700">{t('call') || 'Call'}</span>
        </button>
        
        <button
          onClick={handleNavigate}
          className="flex flex-col items-center justify-center gap-2 p-3 bg-blue-50 rounded-xl active:scale-95 transition-transform"
        >
          <div className="w-10 h-10 bg-[#006491] rounded-full flex items-center justify-center">
            <i className="ri-navigation-line text-white text-lg"></i>
          </div>
          <span className="text-xs font-semibold text-gray-700">{t('navigate') || 'Navigate'}</span>
        </button>
        
        <button
          onClick={handleMessage}
          className="flex flex-col items-center justify-center gap-2 p-3 bg-purple-50 rounded-xl active:scale-95 transition-transform"
        >
          <div className="w-10 h-10 bg-purple-500 rounded-full flex items-center justify-center">
            <i className="ri-message-3-line text-white text-lg"></i>
          </div>
          <span className="text-xs font-semibold text-gray-700">{t('message') || 'Message'}</span>
        </button>
      </div>
    </div>
  );
}
